import { OperationPayload } from './operation-payload.model';
import { Command } from './command.model';
import { OperationType } from './operation-type.enum';

export class Operation {
    static operationTypeStatic: OperationType;
    operationType!: OperationType;
    currentCommand?: Command;
    queueCommands: Command[] = [];
    payload: OperationPayload = {};
}
